import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { classnames } from 'tailwindcss-classnames';
import * as Yup from 'yup';

import ArrowBlack from '../../assets/svg/arrow-black.svg';
import ArrowWhite from '../../assets/svg/arrow-white.svg';
import {
  NEWSLETTER_GROUPS_DISPLAY,
  NEWSLETTER_GROUPS_ID,
} from '../../constants/newsletter';
import Spinner from '../Global/Spinner';

const Newsletter = ({
  full = false,
  fullContent = false,
  group = 'courierWeekly',
  inverse = false,
  legal = true,
  placeholder = '',
  title = '',
}) => {
  const [isLoading, setLoading] = useState(false);
  const [code, setCode] = useState('idle');
  const [response, setResponse] = useState('');
  const [input, setInput] = useState('');
  const [isFocused, setFocused] = useState(false);

  const validationSchema = Yup.string()
    .email('Please enter a valid email address.')
    .required('Please enter a valid email address.');

  const handleChange = (e) => {
    setInput(e.target.value);
    setCode('idle');
    setResponse('');
  };
  const handleMailchimp = async () => {
    try {
      await axios({
        data: { email: input, groupId: NEWSLETTER_GROUPS_ID[group] },
        method: 'put',
        url: '/content/api/mailchimp',
      });
      setCode('success');
    } catch (error) {
      setResponse('We are currently unable to subscribe your email.');
      setCode('error');
    }
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    validationSchema
      .validate(input)
      .then(async () => {
        setLoading(true);
        await handleMailchimp();
        setLoading(false);
      })
      .catch((error) => {
        setResponse(error.message);
      });
  };
  const success = (
    <>
      <div className={`newsletter__success-header ${inverse ? 'inverse' : ''}`}>
        You&apos;re all set.
      </div>
      <div className={`newsletter__success-body ${inverse ? 'inverse' : ''}`}>
        {`Keep a lookout for your first issue of ${NEWSLETTER_GROUPS_DISPLAY[group]}, coming this
    Friday.`}
      </div>
    </>
  );
  const idle = (
    <>
      <div className={`newsletter__title ${inverse ? 'inverse' : ''}`}>
        {title}
      </div>
      <form
        className={classnames(
          'newsletter__form',
          { inverse },
          { error: code === 'error' },
          { 'is-focused': isFocused },
        )}
        noValidate
        onSubmit={(e) => handleSubmit(e)}
      >
        <input
          aria-label={placeholder}
          className={`newsletter__input ${inverse ? 'inverse' : ''}`}
          onBlur={handleBlur}
          onChange={(e) => handleChange(e)}
          onFocus={handleFocus}
          placeholder={placeholder}
          type="email"
          value={input}
        />
        {isLoading ? (
          <Spinner inverse={inverse} />
        ) : (
          <button
            className={`newsletter__button ${inverse ? 'inverse' : ''}`}
            data-component-id="newsletter_subscirbe_form"
            type="submit"
          >
            {inverse ? (
              <ArrowWhite aria-label="Submit" />
            ) : (
              <ArrowBlack aria-label="Submit" />
            )}
          </button>
        )}
      </form>
      <div className="newsletter__response">{response}</div>
      {legal && (
        <div className={`newsletter__legal ${inverse ? 'inverse' : ''}`}>
          {`You can unsubscribe at any time using the link in our emails. For
    more details, review our `}
          <a
            href="https://couriermedia.com/legal/privacy-policy/"
            rel="noreferrer"
            target="_blank"
          >
            privacy policy
          </a>
          .
        </div>
      )}
    </>
  );

  return (
    <div
      className={`newsletter__wrapper ${full ? 'full' : ''}  ${fullContent ? 'fullContent' : ''
        }`}
    >
      {/* Success */}
      {code === 'success' ? success : idle}
    </div>
  );
};

Newsletter.propTypes = {
  full: PropTypes.bool,
  fullContent: PropTypes.bool,
  group: PropTypes.oneOf(['courierWeekly', 'courierWorkshop']),
  inverse: PropTypes.bool,
  legal: PropTypes.bool,
  placeholder: PropTypes.string,
  title: PropTypes.string,
};

export default Newsletter;
